<template>
  <div>
    <span v-if="fileExists && 1==2">{{ file.name }}</span>
    <div v-if="!fileExists && isEditable" class="btn-file mt-0" :class="{'d-block': hasDefaultSlot, 'btn btn-primary btn-simple': !hasDefaultSlot}">
      <slot></slot>
      <span class="fileinput-new" v-if="!hasDefaultSlot">
          <i class="tim-icons icon-cloud-upload-94 ml-0 pl-0 mr-2"></i>
          {{fileExists ? changeText : selectText}}</span> <input type="hidden" value="" name=""/>
      <input type="file" id="file" ref="file" @change="handleFile()"/>
    </div>

    <base-button class="ml-2 btn-download" v-if="file.download" @click="downloadFile()" size="sm" type="primary">
      <i class="fas fa-download"></i> <span class="pl-2">{{downloadText}}</span>
    </base-button>

    <!--<base-button class="ml-2" v-if="fileExists && isEditable" @click="removeFile" size="sm" icon type="danger">-->
      <!--<i class="fas fa-times"></i>-->
    <!--</base-button>-->

  </div>
</template>

<script>
  import {FileUploadService} from "@/services";

  export default {
    name: 'question-box-file',
    data() {
      return {
        file: {},
        fileId: null
      }
    },
    props: {
      question: {
        type: Object
      },
      loggedUser: {
        type: Object
      },
      selectText: {
        type: String,
        default: function () {
          return this.$t('general.upload')
        }
      },
      changeText: {
        type: String,
        default: function () {
          return this.$t('general.change')
        }
      },
      removeText: {
        type: String,
        default: function () {
          return this.$t('general.remove')
        }
      },
      downloadText: {
        type: String,
        default: function () {
          return this.$t('general.download')
        }
      },
      isEditable: {
        type: Boolean,
        default: true
      },
      fileData: {
        default: function () {
          return {}
        }
      }
    },
    model: {
      event: 'file'
    },
    created() {
      this.file = this.fileData;
      if (this.file.id) {
        this.fileId = this.file.id;
      }
    },
    computed: {
      fileExists() {
        return this.file.name !== undefined;
      },
      hasDefaultSlot: function () {
        return this.$slots.default !== undefined && this.$slots.default.length;
      }
    },
    methods: {
      async handleFile() {
        let vm = this;
        if (this.$refs.file.files.length > 0) {
          this.file = this.$refs.file.files[0];

          let formData = new FormData();
          formData.append('file', this.file);

          await FileUploadService.uploadClarificationFile({
            clarification_question_id: vm.question.clarification_question_id,
            formData: formData
          }).then(function (response) {


          }).catch(function (error) {

          })

          vm.$emit('on-file-update', true);
        }
      },
      downloadFile() {
        var win = window.open(this.file.download, '_blank');
        win.focus();
      },
      async removeFile() {
        if (!(this.file instanceof File) && this.file.id && this.file.download && !confirm(this.$t('general.confirm_file_delete_1') + '\n\r' + this.$t('general.confirm_file_delete_2'))) {
          return;
        }

        if (this.file.id) {
          await FileUploadService.deleteClarificationFile(this.file.id).then(function (response) {

          }).catch(function (error) {

          })
        }

        this.fileId = null;
        this.file = {};
        this.$emit('file', this.file);
      }
    },
    watch: {
      fileData: {
        handler: function (newValue) {
          if (!(newValue instanceof File)) {
            this.file = newValue;
          }
        },
        deep: true
      }
    }
  }
</script>
<style>
  .btn-download {
    height: 1.875rem;
  }
</style>